import { render, staticRenderFns } from "./Tabulations.vue?vue&type=template&id=364e7082&scoped=true"
import script from "./Tabulations.vue?vue&type=script&lang=js"
export * from "./Tabulations.vue?vue&type=script&lang=js"
import style0 from "./Tabulations.vue?vue&type=style&index=0&id=364e7082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e7082",
  null
  
)

export default component.exports